import { ChangeDetectionStrategy, Component, inject, input, signal} from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { OrganizationStoreService } from '../../../organizations/services/organization-store.service';
import { Button } from "primeng/button";
import { ActivatedRoute } from '@angular/router';
import { AsyncApiService } from '@spike/core';
import { Order } from '../../models/order.model';
import { Position } from '../../models/position.model';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-print-operations',
  providers:[],
  imports: [TableModule, CommonModule, Button],
  templateUrl: './print-operations.html'
})

export class PrintOperationsComponent extends AbstractComponent{

  public readonly organizationStore = inject(OrganizationStoreService);
  public readonly route = inject(ActivatedRoute);
  private readonly asyncApi = inject(AsyncApiService);

  public readonly order = signal<Order|undefined>(undefined);
  public readonly position = signal<Position|undefined>(undefined);

  orderId: string | null = null;
  positionId: string | null = null;



  async ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.orderId = params.get('orderId');
    });

    this.route.queryParamMap.subscribe(params => {
      this.positionId = params.get('positionId');
    });

    await this.cerca();
    console.log('Order ID:', this.orderId);
    console.log('Position ID:', this.positionId);
    
  }
  
  printPage() {
    window.print();
  }


  async cerca(){
    if(this.orderId && this.positionId) {
      let order = await this.asyncApi.call<Order>(EntityApiEnum.ORDER,'selectByIdFull', {id: this.orderId});
      if(order && order.positions){
        this.order.set(order);
        let position = order.positions.find(p=> p.positionId === +this.positionId!);
        this.position.set(position);
      }     

    }
  }
}
  

